<template>
  <base-content>
    <template v-slot:top>
      <hero-header heading="Portfolio Investments">
        <p>
          To find out more about our Portfolio Investments and our 100% IHT Relief Portfolios, please download our guide.
        </p>
        <base-button href="/docs/portfolio-investment-guide.pdf" secondary target="_blank">
          Download Investment Guide
        </base-button>
      </hero-header>
    </template>
    <portfolio-opportunities />
  </base-content>
</template>

<script>
import HeroHeader from '@/components/HeroHeader.vue'
import PortfolioOpportunities from '@/components/PortfolioOpportunities.vue'

export default {
  components: {
    HeroHeader,
    PortfolioOpportunities
  }
}
</script>
